import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MarketMegamarketApi from '../../../../API/market/megamarket-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { Select } from '../../../../components/Basic/Inputs';
import { MarketsSearch, MarketsTable } from '../../../../components/Markets';
import MarketsFilter, { FRONT_ERRORS, FRONT_WARNING } from '../../../../components/Markets/Blocks/Filter';
import { MARKET_MODES, MARKETS_MAP, MEGAMARKET_MARKETS_MAP, TYPE_BUTTONS } from '../../../../constans';
import styles from './styles.module.scss';

export const WIDTH_MEGAMARKET = [
  '90px',
  '160px',
  '400px',
  '100px',
  '100px',
  '60px',
  '150px',
  '180px',
  '200px',
  '150px',
];

export const FILTER_MARKETPLACE = {
  0: 'all',
  1: 'instock',
  2: 'nullstock',
  3: 'warehouse',
  4: 'outofstock',
  5: 'stopbrand',
  6: 'notupdated',
  7: 'error',
  8: 'warning',
  9: 'minus',
};

const MegamarketTable = ({
  isExpress = false,
  updateProviderStocksAndPrice = () => { },
  updateProviderPrice = () => { },
}) => {
  const [show, setShow] = useState(50);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  const [count, setCount] = useState([]);
  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });
  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [error, setError] = useState(Object.keys(FRONT_ERRORS)[0]);
  const [warning, setWarning] = useState(Object.keys(FRONT_WARNING)[0]);

  const [cards, setCards] = useState({ ids: [], byId: {} });

  const [productsSelect, setProductsSelect] = useState({});
  const [checkAll, setCheckAll] = useState(false);
  const [errorsGroup, setErrorsGroup] = useState({});
  const [warningsGroup, setWarningsGroup] = useState({});
  const [contentMode, changeMode] = useState(MARKET_MODES[0]);

  const shop = useSelector((store) => store.sbermarket.market);
  const { role } = useSelector((store) => store.user);

  const dispatch = useDispatch();

  const onChangePage = (v) => {
    setPage(v);
  };

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_select = {};
      cards.ids.forEach((item) => {
        map_select[cards.byId[item].offer_id] = true;
      });
      setProductsSelect(map_select);
      setCheckAll(true);
    } else {
      setCheckAll(false);

      setProductsSelect({});
    }
  };

  const changeProductSelect = (artnumber) => {
    if (productsSelect[artnumber]) {
      const s = productsSelect;
      delete s[artnumber];
      setProductsSelect({ ...s });
    } else {
      setProductsSelect({ ...productsSelect, [artnumber]: true });
    }
  };

  const params = useMemo(() => {
    return {
      search: search.trim(),
      limit: parseInt(show),
      shop: MEGAMARKET_MARKETS_MAP[shop],
      page,
      providerId: provider.id,
      tab: FILTER_MARKETPLACE[tab],
      filters: {
        errorType: error === 'null' ? null : error,
        warningType: warning === 'null' ? null : warning,
      },
    };
  }, [search, show, shop, page, tab, provider.id, error, warning]);

  const params_excel = useMemo(() => {
    return {
      ...params,
      limit: undefined,
      page: undefined,
    };
  }, [params]);

  const loadCards = () => {
    MarketMegamarketApi.getCardsBySearch({ data: params }).then((r) => {
      const {
        allstock,
        instock,
        nullstock,
        archivestock,
        outofstock,
        warehousestock,
        stopbrand,
        errostock = 0,
        warningstock = 0,
        minusstock,
        notupdated = 0,
      } = r.stock;
      const byIds = {};
      const id = r.cards.map((item) => item.offer_id);
      r.cards.forEach((item) => (byIds[item.offer_id] = item));

      setCards({ byId: byIds, ids: id });
      setProductsSelect({});
      setErrorsGroup(r.errorsGroup);
      setWarningsGroup(r.warningsGroup);
      setCheckAll(false);
      setCountStock([
        allstock,
        instock,
        nullstock,
        warehousestock,
        outofstock,
        stopbrand,
        notupdated,
        errostock,
        warningstock,
        minusstock,
        archivestock,
      ]);

      setCount(r.stock.count);
    });
  };

  useEffect(() => {
    loadCards();
  }, [params]);

  const onChangeTab = (n) => {
    setTab(n);
  };

  const onChangeCard = async (offer_id, key, value) => {
    if (cards.byId[offer_id][key] === value) {
      return;
    }
    let setCard = (card) => {
      setCards({ ...cards, byId: { ...cards.byId, [offer_id]: card } });
    };

    let setCardLocal = (card) => {
      setCards({ ...cards, byId: { ...cards.byId, [offer_id]: { ...cards.byId[offer_id], [key]: value } } });
    };

    if (key === 'stock') {
      return await MarketMegamarketApi.changeStock({ data: { shop: MARKETS_MAP[shop], offer_id, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'price') {
      return await MarketMegamarketApi.changePrice({ data: { shop: MARKETS_MAP[shop], offer_id, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'percent' || key === 'min_rub') {
      return await MarketMegamarketApi.changeMarginality({ data: { shop: MARKETS_MAP[shop], offer_id, field: key, value: parseInt(value) } })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'archive') {
      return await MarketMegamarketApi.changeArchive({ data: { shop: MARKETS_MAP[shop], offerIds: [offer_id], value } })
        .then((r) => {
          loadCards();
        })
        .catch((e) => console.log(e));
    }
    if (key === 'stopbrand') {
      return await MarketMegamarketApi.changeStopBrand({ data: { shop: MARKETS_MAP[shop], offerIds: [offer_id], value } })
        .then((r) => {
          loadCards();
        })
        .catch((e) => console.log(e));
    }
    return await MarketMegamarketApi.changeCard({ data: { shop: MARKETS_MAP[shop], offer_id, field: key, value } })
      .then((r) => {
        setCard(r.card);
      })
      .catch((e) => console.log(e));
  };

  const onChangeCards = async (offerIds, key, value) => {
    if (key === 'archive') {
      return await MarketMegamarketApi.changeArchive({ data: { shop: MARKETS_MAP[shop], offerIds, value } })
        .catch((e) => console.log(e));
    }
    if (key === 'stopbrand') {
      return await MarketMegamarketApi.changeStopBrand({ shop: { shop: MARKETS_MAP[shop], offerIds, value } })
        .then((card) => {
          loadCards();
        })
        .catch((e) => console.log(e));
    }
    if (key === 'stock') {
      return await updateProviderStocksAndPrice(undefined, value, offerIds).then(() => {
        setCheckAll(false);
        setProductsSelect({});
      });
    }
    if (key === 'price') {
      return await updateProviderPrice(undefined, offerIds).then(() => {
        setCheckAll(false);
        setProductsSelect({});
      });
    }
    if (key === 'delete') {
      return await MarketMegamarketApi.deleteCards({ data: { shop: MARKETS_MAP[shop], offerIds } }).then(() => {
        setCheckAll(false);
        setProductsSelect({});
      });
    }
  };

  useEffect(() => {
    setError(Object.keys(FRONT_ERRORS)[0]);
    setWarning(Object.keys(FRONT_WARNING)[0]);
  }, [tab]);

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, { name: 'Не заполнен', id: -1 }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: 'Не выбран', id: null });
    }
  }, [allProviders]);

  const isOwner = role === 'owner' || 'admin';

  return (
    <>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={[
              'Все товары',
              'В продаже',
              'Готовы к продаже',
              'На складе',
              'Выведено из ассортимента',
              'Стоп бренды',
              'Не обновлено',
              'С ошибками',
              'Предупреждение',
              'В минус',
            ]}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />

          <div>
            <Select select={contentMode} list={MARKET_MODES} onSelect={(v) => changeMode(v)} width="150px" />
          </div>
        </Row>

        <MarketsSearch
          market={'MM'}
          search={search}
          selectTab={FILTER_MARKETPLACE[tab]}
          count={count}
          productsSelect={productsSelect}
          setSearch={setSearch}
          setCheckAll={setCheckAll}
          setProductsSelect={setProductsSelect}
          onArchive={(offerIds, state) => onChangeCards(offerIds, 'archive', state)}
          onStopbrand={(offerIds, state) => onChangeCards(offerIds, 'stopbrand', state)}
          updateStocks={(offerIds, state) => onChangeCards(offerIds, 'stock', state)}
          updatePrices={(offerIds) => onChangeCards(offerIds, 'price')}
          onDelete={(offerIds) => onChangeCards(offerIds, 'delete')}
        />

        <Row spaceBetween={true}>
          <MarketsFilter
            selectTab={FILTER_MARKETPLACE[tab]}
            show={show}
            tab={tab}
            provider={provider}
            providers={providers}
            error={error}
            setShow={setShow}
            setError={setError}
            setWarning={setWarning}
            changeProvider={changeProvider}
            errorsGroup={errorsGroup}
            warningsGroup={warningsGroup}
          />
          <Column className={styles.column_button}>
            <Row>
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() => MarketMegamarketApi.excelPrices({ data: params_excel })}
                style={{ marginRight: '15px' }}
              >
                Скачать прайс
              </Button>
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() => MarketMegamarketApi.excelData({ data: params_excel })}
                style={{ marginRight: '15px' }}
              >
                Скачать данные
              </Button>
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() => MarketMegamarketApi.excelAnalitycs({ data: params_excel })}
                style={{ marginRight: '15px' }}
              >
                Скачать аналитику
              </Button>
            </Row>
          </Column>
        </Row>
      </WhiteBlock>
      <MarketsTable
        market={'MM'}
        contentMode={contentMode}
        checkAll={checkAll}
        clickCheckAll={clickCheckAll}
        isExpress={isExpress}
        isOwner={isOwner}
        cards={cards}
        count={count}
        show={show}
        page={page}
        errorsGroup={errorsGroup}
        productsSelect={productsSelect}
        selectTab={FILTER_MARKETPLACE[tab]}
        onChangePage={onChangePage}
        changeProductSelect={changeProductSelect}
        onChangeProduct={onChangeCard}
      />
    </>
  );
};

export default MegamarketTable;
